import { format, parseISO } from 'date-fns'

import { isCorrectDate } from './isCorrectDate'

import { DATE_FORMATS } from '~constants'

export const formatDate = (
  date?: Date | string,
  dateFormat: DATE_FORMATS = DATE_FORMATS.US_SLASHED_FORMAT
) => {
  if (!isCorrectDate(date)) return ''

  if (typeof date === 'string') {
    return format(parseISO(date), dateFormat)
  }

  return format(date, dateFormat)
}
